export default "/images/ic_occurrence_success.svg?efe457ca0ffedda7def78140fbd7b4e3";